module.exports = __webpack_public_path__ + "static/media/Facecut.ffc473ab.png";